/**
 * Los ids de la sesión de Microsoft Clarity que está grabando esta página, para poder abrir la
 * grabación desde el panel de ingresos.
 *
 * Archivo SIN dependencias a propósito: lo leen el interceptor del cliente HTTP (`api-client.ts`)
 * y los beacons del antibot, y lo escribe `tracker.ts`. Si viviera en el tracker se armaría el
 * ciclo api-client → tracker → consent → api-client.
 *
 * Los escribe el callback de `clarity("metadata", …)` en cada página, y sólo con consentimiento de
 * analítica: sin él Clarity no carga, y si se revoca se borran (después de revocar Clarity puede
 * seguir con ids por página, que no sirven para enlazar nada y no corresponde guardar).
 */

export type ClarityIds = {
  projectId: string;
  userId: string;
  sessionId: string;
  pageNum: number;
};

/** Los ids de Clarity son base36: nunca traen puntos, así que el header los puede unir con ".". */
const CLARITY_ID = /^[0-9a-z]{1,32}$/i;

let current: ClarityIds | null = null;

export function setClarityIds(ids: ClarityIds | null | undefined) {
  if (
    ids &&
    CLARITY_ID.test(String(ids.projectId)) &&
    CLARITY_ID.test(String(ids.userId)) &&
    CLARITY_ID.test(String(ids.sessionId))
  ) {
    const pageNum = Number(ids.pageNum);
    current = {
      projectId: String(ids.projectId),
      userId: String(ids.userId),
      sessionId: String(ids.sessionId),
      pageNum: Number.isInteger(pageNum) && pageNum >= 0 ? pageNum : 0,
    };
    return;
  }
  current = null;
}

export function getClarityIds(): ClarityIds | null {
  return current;
}

/**
 * `<projectId>.<userId>.<sessionId>.<pageNum>`: el valor del header `X-Clarity` (y del campo
 * `clarity` de los beacons, que no pueden mandar headers). null sin ids.
 */
export function clarityHeaderValue(): string | null {
  return current
    ? `${current.projectId}.${current.userId}.${current.sessionId}.${current.pageNum}`
    : null;
}
